<template>
  <section class="logo p-t-17 has-text-centered is-full-width is-hidden-mobile">
    <img
      class="has-width-160 has-height-50 has-object-fit-contain is-hidden-tablet-only"
      :src="logo"
    />
    <img
      class="has-width-160 has-height-50 has-object-fit-contain is-hidden-desktop"
      :src="logoResponsive"
    />
    <div v-if="isPoweredBy" class="mt-2 is-hidden-tablet-only">
      <div class="is-flex m-l-30">
        <span
          :data-e2e="NavCypressAttribute.texts.POWERED_BY_TEXT"
          class="is-uppercase has-text-weight-semibold is-size-7"
        >
          {{ $t('core.powered-by') }}
        </span>
        <span class="m-l-5"><ClearEstateLogo size="tiny" /></span>
      </div>
    </div>
  </section>
</template>

<script>
import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';
import ClearEstateLogo from '/@/modules/core/app/components/ClearEstateLogo.vue';
import { HasCurrentEstateMixin } from '/@/modules/core/app/mixins/HasCurrentEstateMixin';
import HasCompanyMixin from '/@/modules/company/mixins/HasCompanyMixin';
import { NavCypressAttribute } from '/@/modules/core/nav/constants/NavCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CompanyLogoContainer',
  mixins: [HasAuthUserMixin, HasCurrentEstateMixin, HasCompanyMixin],
  components: { ClearEstateLogo },
  static: {
    NavCypressAttribute
  }
};
</script>
